import React from 'react';
import { Helmet } from 'react-helmet-async';
import DeviationMediaService from '../../../utils/DeviationMediaService';
export const PdfFullView = ({ deviation , width , height  })=>{
    const pdfFiles = DeviationMediaService.getMediaByType(deviation, 'pdf');
    if (!pdfFiles || pdfFiles.length === 0) {
        return null;
    }
    const pdfFile = pdfFiles.pop();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Helmet, null, /*#__PURE__*/ React.createElement("link", {
        rel: "preload",
        href: pdfFile.src,
        as: "object"
    })), /*#__PURE__*/ React.createElement("object", {
        "aria-label": deviation.title,
        data: pdfFile.src,
        style: {
            width,
            height
        },
        type: "application/pdf"
    }));
};
export default PdfFullView;
